import React, { useEffect, useState } from "react";
import classes from "./CompareTop.module.scss";
import BreadCrumb from "../../molecules/breadcrumb/BreadCrumb";
import { useNavigate } from "react-router-dom";
import charJumpImage from "../../static/images/prepare/char-jump.png";
import topHeader1 from "../../static/images/compare/top-header-1.png";
import topHeader2 from "../../static/images/compare/top-header-2.png";
import topbody from "../../static/images/compare/top-body.png";
import topExplanation from "../../static/images/compare/top-explanation.png";
import SimpleButton from "../../atoms/simple-button/SimpleButton";
import { useLoginStatus } from "../../common/hooks/useLoginStatus";
import Header from "../../molecules/header/Header";
import { fetchUser, User } from "../../api/UsersApi";
import { isCompareInputCompleted } from "../../common/utility/compare.util";

function CompareTop() {
  const navigate = useNavigate();
  const { isLoggedIn } = useLoginStatus();
  const userApi = fetchUser();
  const [startRequested, setStartRequested] = useState(false);

  useEffect(() => {
    if (isLoggedIn) {
      userApi.fetch();
    }
  }, [isLoggedIn]);

  const navigateByUserInputStatus = (user?: User) => {
    navigate(
      isCompareInputCompleted(user)
        ? "/comparenavi/result"
        : "/comparenavi/input"
    );
  };

  const handleStart = () => {
    if (isLoggedIn === null) return;
    if (!isLoggedIn) {
      navigate("/comparenavi/input");
      return;
    }

    if (userApi.state?.status === "success") {
      navigateByUserInputStatus(userApi.state.data?.[0]);
      return;
    }

    setStartRequested(true);
    if (userApi.state?.status !== "processing") {
      userApi.fetch();
    }
  };

  useEffect(() => {
    if (!startRequested || !isLoggedIn) return;
    if (userApi.state?.status !== "success") return;

    setStartRequested(false);
    navigateByUserInputStatus(userApi.state.data?.[0]);
  }, [startRequested, isLoggedIn, userApi.state]);

  return (
    <div className={classes.container}>
      {isLoggedIn && <Header />}
      <div className={classes.body}>
        <div className={classes.topHeaderContainer}>
          <div className={classes.row1}>
            <img
              className={classes.topHeader1}
              src={topHeader1}
              alt="比較ナビ トップヘッダー1"
            />
            <img
              className={classes.topHeader2}
              src={topHeader2}
              alt="比較ナビ トップヘッダー2"
            />
          </div>
        </div>
        <div className={classes.topBodyContainer}>
          <img src={topbody} alt="比較ナビ トップボディ" />
        </div>
        <div className={classes.topExplanationContainer}>
          <img src={topExplanation} alt="比較ナビ コンテンツ説明" />
        </div>
        <div className={classes.commentArea}>
          <div>
            <div className={classes.orangeComment}>みらいい認定FPが監修</div>
            <div className={classes.orangeComment}></div>
            <div className={classes.blackComment}>※統計データ・調査データを活用。</div>
            <div className={classes.blackComment}>※無料・匿名で利用できます。</div>
          </div>
        </div>
          <div className={classes.buttonArea} onClick={handleStart}>
            <img className={classes.teacherBottom} src={charJumpImage} alt="キャラ ジャンプ" />
            <SimpleButton width={"90%"} label={"さっそくはじめる！"}/>
          </div>
        {/* パンくず */}
        {isLoggedIn ? (
          <BreadCrumb
            data={[
              { displayName: "みらいいコンシェル", url: "/top" },
              { displayName: "くらべてナビ", url: "/comparenavi" },
            ]}
          />
        ) : (
          <BreadCrumb
            data={[
              { displayName: "みらいいコンシェル", url: "/top" },
              { displayName: "くらべてナビ", url: "/comparenavi" },
            ]}
          />
        )}
      </div>
    </div>
  );
}

export default CompareTop;
